import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-project_write",
  "use": "icon-project_write-usage",
  "viewBox": "0 0 28 28",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 28 28\" id=\"icon-project_write\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"2\" stroke-linecap=\"round\"><path d=\"M24 16.179h0V22.417C24 23.29 23.291 24 22.417 24H6.583A1.583 1.583 0 015 22.417V6.583C5 5.71 5.709 5 6.583 5h6.34M13.98 14.904l9.838-9.818\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol